export default __webpack_public_path__ + "204f8f6.png";